import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CompanyReportSectionType } from '../metroline/types';
import { CompanyReportSection } from '../types';
import { ExcelMappingsContainer } from './excel-mappings-container';

export const ExcelMappings: React.FC<CompanyReportSection> = ({
  companyReportItem, updateItem, validation, translation, section, getRef, shouldRenderSection
}) =>
  <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.ExcelMappings}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.ExcelMappings)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.ExcelMappings}
        validation={undefined}
        info={{ visible: true, text: translation.excel_mappings_info_text }}
        label={{ visible: true, text: translation.excel_mappings }} />
      <MainGridContainer>
        <ExcelMappingsContainer
          companyReportItem={companyReportItem}
          updateItem={updateItem}
          validation={validation}
          translation={translation} />
      </MainGridContainer>
    </div>
  </MetroLineSection>;
